export const INVALID_UPSELL_CODES = [
  'FR',
];
